import { Container, Content, Group, PaginationFooter, QuestionsFind } from './styles'
import Filters from '../Filters'
import { useGetQuestions } from '../../hooks/use-get-questions'
import QuestionForPage from '../../../../components/QuestionForPage'
import { AiOutlineArrowLeft } from 'react-icons/ai'
import { useHistory } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { RiArrowUpSLine } from 'react-icons/ri'
import { animateScroll } from 'react-scroll'
import NotQuestion from '../../../../components/NotQuestion'

import Pagination from '../../../../components/QuestionForPage/Pagination'
import { useWindowSize } from 'react-use'
import ModalShortcuts from '../../../QuestionBook/components/QuestionBookComponent/ModalShortCuts'
import { switchColorMode } from '../../../../store/modules/theme/actions'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'

import { useTracking } from 'react-tracking'
import { TrackingSchemaTypes } from '../../../../tracking'
import QuestionsList from '../QuestionsList'

const SearchQuestionsContent = () => {
  const history = useHistory()
  const { width } = useWindowSize()
  const intersectionRef = useRef(null)

  const isMobile = width <= 800

  const {
    swr: swrQuestions,
    pagination,
    allPages,
    params: { filters, setFilters, itemsPerPage, setItemsPerPage, setOrderBy, mostRecent },
  } = useGetQuestions({ isMobile })

  const [fontSize, setFontSize] = useState(16)
  const [openModalShortcuts, setOpenModalShortcuts] = useState<boolean>(false)
  const [tracking, setTracking] = useState({
    event: null,
    properties: {},
  })

  const { trackEvent } = useTracking()

  const isLoading = swrQuestions.isLoading || Boolean(swrQuestions.error)
  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const [hideTheme, setHideTheme] = useState(false)
  const dispatch = useDispatch()
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [scrol, setScrol] = useState<number>()

  const displayScrollToTop = isMobile || itemsPerPage !== 1

  const scrollToTop = () => {
    animateScroll.scrollToTop({
      duration: 500,
      smooth: 'easeInOutQuad',
    })
  }

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const { isIntersecting = false } = entries[0]

      if (isIntersecting && isMobile && !isLoading) {
        pagination.next()
      }
    })

    if (intersectionRef.current) {
      observer.observe(intersectionRef.current)
    }

    return () => {
      if (intersectionRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(intersectionRef.current)
      }
    }
  }, [isMobile, pagination, isLoading])

  useEffect(() => {
    if (tracking.event)
      trackEvent({
        event: TrackingSchemaTypes[tracking.event],
        properties: tracking.properties,
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tracking])

  const flattenPages = allPages.map((pages) => pages?.docs).flat()

  useEffect(() => {
    const handleKeyPress = (event) => {
      const letter = event.key
      if (window.innerWidth >= 1080 && itemsPerPage === 1) {
        if (letter === 'ArrowRight' || event.keyCode === 102) {
          if (pagination.active !== pagination.total) {
            pagination.next()
          }
        } else if (letter === 'ArrowLeft' || event.keyCode === 100) {
          if (pagination.active !== 1) {
            pagination.previous()
          }
        } else if (letter === 'K' || letter === 'k') {
          if (scrol >= 380) {
            dispatch(switchColorMode({ isDarkMode: !isDarkMode }))
          }
        } else if (letter === 'I' || letter === 'i') {
          setHideTheme(!hideTheme)
        }
      }
    }
    window.addEventListener('keydown', handleKeyPress)
    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [dispatch, hideTheme, isDarkMode, itemsPerPage, pagination, scrol])
  function showScrollPosition() {
    const scrollY = window.scrollY || window.pageYOffset
    setScrol(scrollY)
  }

  window.addEventListener('scroll', showScrollPosition)
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (window.innerWidth > 800 && itemsPerPage === 1) {
        if (openModal === false && scrol >= 380) {
          switch (event.key) {
            case 'A':
            case 'a':
            case '1':
              {
                const alternativeA = document.querySelector('#alternative-A') as HTMLDivElement

                alternativeA.focus()
                alternativeA.click()
              }

              break
            case 'B':
            case 'b':
            case '2':
              {
                const alternativeB = document.querySelector('#alternative-B') as HTMLDivElement

                alternativeB.focus()
                alternativeB.click()
              }
              break
            case 'C':
            case 'c':
            case '3':
              if (swrQuestions.data.docs[0].type === 'CERTO_ERRADO' && event.key !== '3') {
                {
                  const alternativeA = document.querySelector('#alternative-A') as HTMLDivElement

                  alternativeA.focus()
                  alternativeA.click()
                }
              } else {
                {
                  const alternativeB = document.querySelector('#alternative-C') as HTMLDivElement

                  alternativeB.focus()
                  alternativeB.click()
                }
              }
              break
            case 'D':
            case 'd':
            case '4':
              {
                const alternativeB = document.querySelector('#alternative-D') as HTMLDivElement

                alternativeB.focus()
                alternativeB.click()
              }
              break
            case 'E':
            case 'e':
            case '5':
              if (swrQuestions.data.docs[0].type === 'CERTO_ERRADO' && event.key !== '5') {
                {
                  const alternativeA = document.querySelector('#alternative-B') as HTMLDivElement

                  alternativeA.focus()
                  alternativeA.click()
                }
              } else {
                {
                  const alternativeB = document.querySelector('#alternative-E') as HTMLDivElement

                  alternativeB.focus()
                  alternativeB.click()
                }
              }

              break
            case 'Enter': {
              const target = event.target as HTMLDivElement

              if (target.id.includes('alternative-') && target.dataset.selected === 'true') {
                const submitButton = document.querySelector('#submitButton') as HTMLDivElement

                submitButton.click()
              }
            }
          }
        }
      }
    }

    window.addEventListener('keydown', handleKeyPress)
    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [itemsPerPage, openModal, scrol, swrQuestions.data])

  return (
    <Container>
      <Content>
        <Group>
          <div className="divBeta">
            <h1 className="title">
              <AiOutlineArrowLeft className="icon" onClick={history.goBack} color="#FF6600" />
              Questões de concursos
            </h1>
          </div>

          <Filters setTracking={setTracking} setFiltersParams={setFilters} isLoading={isLoading} />
          <QuestionsFind>
            {isLoading ? (
              <div className="loading-block" />
            ) : (
              <>
                <b>{new Intl.NumberFormat('pt-BR').format(swrQuestions.data.total || 0)}</b>
                questões encontradas
              </>
            )}
          </QuestionsFind>
        </Group>
        {swrQuestions.isLoading === false && swrQuestions.data.total === undefined ? (
          <NotQuestion />
        ) : (
          <>
            <QuestionForPage
              pagination={pagination}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              setOrderBy={setOrderBy}
              setFontSize={setFontSize}
              filtersParams={filters}
              totalQuestions={swrQuestions.data.total}
              isLoading={isLoading}
              mostRecent={mostRecent}
              setOpenModalShortcuts={setOpenModalShortcuts}
              setOpenModal={setOpenModal}
              openModal={openModal}
              setTracking={setTracking}
            />
            <QuestionsList
              id={'questionss'}
              fontSize={fontSize}
              hideTheme={hideTheme}
              setHideTheme={setHideTheme}
              isMobile={isMobile}
              page={pagination.active}
              itemsPerPage={itemsPerPage}
              isLoading={swrQuestions.isLoading}
              data={isMobile ? flattenPages : swrQuestions.data.docs}
              setTracking={setTracking}
            />

            <PaginationFooter>
              <Pagination pagination={pagination} />
            </PaginationFooter>
          </>
        )}
        <div ref={intersectionRef} className="desk" />
        {displayScrollToTop && (
          <button className="scroll-button" onClick={scrollToTop} tabIndex={-1}>
            <RiArrowUpSLine size={25} color="#394A64" />
          </button>
        )}
      </Content>
      <ModalShortcuts isOpen={openModalShortcuts} onClose={() => setOpenModalShortcuts(false)} />
    </Container>
  )
}

export default SearchQuestionsContent
